import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { getPublicUrl } from "../utils/utils";
import store from "store";

class Header extends Component {
  constructor(props) {
    super(props);

    try {
      this.isProductTypeAudio = false;
      this.product = store.get("product");
      if (this.product && this.product.productType === "audio") {
        this.isProductTypeAudio = true;
      }
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  }

  render() {
    const { t, i18n } = this.props;
    let homeUrl = getPublicUrl(i18n);
    if (this.isProductTypeAudio) {
      homeUrl = "/audio";
    }
    return (
      <header id="js-header" className="u-header u-header--static ">
        <div className="u-header__section g-bg-main-light-v1 g-transition-0_3">
          <div className="container">
            <div className="d-flex justify-content-between">
              <div>
                <a className="navbar-brand" href={homeUrl}>
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/img/mimiMaps_white.png"
                    }
                    className="img-fluid"
                    style={{ maxHeight: "48px" }}
                    alt="mimiMaps"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default withTranslation()(Header);
